export default {
      id: "ic-labels-usage",
      viewBox: "0 0 60 60",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-labels-usage",
      toString: function () {
        return this.url;
      }
    }